import { Link } from "react-router-dom";
import { Facebook, Instagram, Users, Star, ShieldCheck, Award, Phone, Mail, MapPin } from "lucide-react";
import { BRAND, LOCATIONS } from "../data/siteData";
import { Logo } from "./Header";

const QUICK_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
  { to: "/free-estimate", label: "Free Estimate" },
];

export const Footer = () => (
  <footer className="bg-[#0a0a0a] border-t border-white/10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
      <div>
        <Logo variant="light" className="h-14" />
        <p className="text-gray-400 text-sm leading-relaxed mt-4">
          Phoenix's premier garage floor coating company. The TRI-BOND™ polyaspartic system — installed in one day, backed for life.
        </p>
        <div className="flex gap-4 mt-6">
          <a href={BRAND.social.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="text-gray-400 hover:text-[#028090] transition-colors duration-200"><Facebook size={20} strokeWidth={1.5} /></a>
          <a href={BRAND.social.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="text-gray-400 hover:text-[#028090] transition-colors duration-200"><Instagram size={20} strokeWidth={1.5} /></a>
          <a href={BRAND.social.nextdoor} target="_blank" rel="noopener noreferrer" data-testid="footer-nextdoor" aria-label="Nextdoor" className="text-gray-400 hover:text-[#028090] transition-colors duration-200"><Users size={20} strokeWidth={1.5} /></a>
          <a href={BRAND.social.google} target="_blank" rel="noopener noreferrer" data-testid="footer-google" aria-label="Google Business Profile" className="text-gray-400 hover:text-[#E8B86D] transition-colors duration-200"><Star size={20} strokeWidth={1.5} /></a>
        </div>
        <div className="flex flex-col gap-2 mt-6">
          <span className="flex items-center gap-2 text-xs text-gray-400"><ShieldCheck size={15} className="text-[#028090]" strokeWidth={1.5} /> Licensed &amp; Insured</span>
          <span className="flex items-center gap-2 text-xs text-gray-400"><Award size={15} className="text-[#E8B86D]" strokeWidth={1.5} /> Lifetime Limited Warranty</span>
        </div>
      </div>
      <div>
        <h4 className="text-white font-display font-bold uppercase tracking-wider text-sm mb-5">Quick Links</h4>
        <ul className="space-y-3">
          {QUICK_LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`} className="text-gray-400 text-sm hover:text-[#028090] transition-colors duration-200">{l.label}</Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="text-white font-display font-bold uppercase tracking-wider text-sm mb-5">Service Areas</h4>
        <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5">
          {LOCATIONS.map((loc) => (
            <li key={loc.slug}>
              <Link to={`/${loc.slug}`} data-testid={`footer-area-${loc.city.toLowerCase().replace(/\s/g, "-")}`} className="text-gray-400 text-sm hover:text-[#028090] transition-colors duration-200">
                {loc.city === "Phoenix" ? "Phoenix (Epoxy)" : loc.city}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="text-white font-display font-bold uppercase tracking-wider text-sm mb-5">Contact</h4>
        <ul className="space-y-4">
          <li><a href={BRAND.phoneHref} data-testid="footer-phone" className="flex items-center gap-2 text-gray-300 text-sm hover:text-[#028090] transition-colors duration-200"><Phone size={15} className="text-[#028090]" strokeWidth={1.5} /> {BRAND.phone}</a></li>
          <li><a href={`mailto:${BRAND.email}`} data-testid="footer-email" className="flex items-center gap-2 text-gray-300 text-sm hover:text-[#028090] transition-colors duration-200"><Mail size={15} className="text-[#028090]" strokeWidth={1.5} /> {BRAND.email}</a></li>
          <li><span className="flex items-center gap-2 text-gray-400 text-sm"><MapPin size={15} className="text-[#028090]" strokeWidth={1.5} /> {BRAND.area}</span></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
        <p className="text-gray-500 text-xs leading-relaxed">
          Serving the Phoenix Metro Area including Scottsdale, Gilbert, Chandler, Mesa, Tempe, Glendale, Peoria, Queen Creek, Goodyear, Surprise, Paradise Valley &amp; Ahwatukee.
        </p>
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mt-4">
          <p className="text-gray-500 text-xs">© {new Date().getFullYear()} Vantyx Coatings LLC. All rights reserved.</p>
          <div className="flex gap-5">
            <Link to="/warranty" data-testid="footer-warranty" className="text-gray-500 text-xs hover:text-[#028090]">Warranty</Link>
            <Link to="/privacy-policy" data-testid="footer-privacy" className="text-gray-500 text-xs hover:text-[#028090]">Privacy Policy</Link>
            <Link to="/terms-of-service" data-testid="footer-terms" className="text-gray-500 text-xs hover:text-[#028090]">Terms of Service</Link>
          </div>
        </div>
      </div>
    </div>
  </footer>
);
